"use client";

import { createContext, type ReactNode, useContext } from "react";
import type { SiteSettings } from "@/lib/contentful/siteSettings";

const SiteSettingsContext = createContext<SiteSettings | undefined>(undefined);

interface Props {
  value: SiteSettings;
  children: ReactNode;
}

export function SiteSettingsProvider({ value, children }: Props) {
  return <SiteSettingsContext.Provider value={value}>{children}</SiteSettingsContext.Provider>;
}

export function useSiteSettings(): SiteSettings {
  const context = useContext(SiteSettingsContext);
  if (!context) {
    throw new Error("useSiteSettings must be used inside <SiteSettingsProvider>");
  }
  return context;
}
